import ExpenseTypesList from './_ExpenseTypesList';

export default ExpenseTypesList;
